'use client';

import Script from 'next/script';

import { getENV } from '../../utils/env';

export const AdyenDataCollectionLegacy = () => {
    return (
        <Script id="adyen-data-collection-sdk" src={getENV('NEXT_PUBLIC_ADYEN_DATA_COLLECTION_SDK_SCRIPT_URL')} async />
    );
};
